var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcn24X24Next(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00015 4.55377C8.00347 4.69661 8.06233 4.83231 8.16388 4.93125L14.7138 11.5802L8.16388 18.2291C8.11273 18.2795 8.07207 18.3399 8.04431 18.4065C8.01654 18.4732 8.00223 18.5448 8.00223 18.6172C8.00226 18.7248 8.03392 18.83 8.09317 18.9193C8.15241 19.0085 8.23655 19.0778 8.33481 19.1183C8.43308 19.1588 8.541 19.1685 8.64477 19.1464C8.74854 19.1242 8.84344 19.0712 8.91732 18.9939L15.844 11.9626C15.9439 11.8612 16 11.7236 16 11.5802C16 11.4368 15.9439 11.2992 15.844 11.1978L8.91732 4.16642C8.84296 4.08777 8.74691 4.03376 8.64178 4.01148C8.53665 3.9892 8.42734 3.99969 8.32819 4.04156C8.22903 4.08344 8.14465 4.15475 8.08611 4.24615C8.02758 4.33755 7.99761 4.44478 8.00015 4.55377Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcn24X24Next);
export default __webpack_public_path__ + "static/media/icn_24x24_next.fa9281e0b5cc4afe34fa7f32f2dc9180.svg";
export { ForwardRef as ReactComponent };